import deephowApiServerWrapper from "@/server/api-server";

export const postStepResetVideo = ({ workflow_id, step_id }) =>
  deephowApiServerWrapper("post", `/v1/workflows/${workflow_id}/steps/${step_id}/reset`, { workflow_id, step_id });
